'use strict';
module.exports = function (str) {
	var isExtendedLengthPath = /^\\\\\?\\/.test(str);
	var hasNonAscii = /[^\x00-\x80]+/.test(str);

	if (isExtendedLengthPath || hasNonAscii) {
		return str;
	}

	return str.replace(/\\/g, '/');
};



/*****************
 ** WEBPACK FOOTER
 ** ./~/slash/index.js
 ** module id = 416
 ** module chunks = 0
 **/